<script>
import { inject, onMounted, onBeforeUnmount } from 'vue';

export default {
	name: 'MiniTableColumn',
	props: {
		prop: {
			type: String,
			required: true
		},
		label: {
			type: String,
			default: ''
		},
		width: {
			type: [String, Number],
			default: ''
		},
		align: {
			type: String,
			default: '',
			validator: value => ['', 'left', 'center', 'right'].includes(value)
		},
		// 列标题 Label 区域渲染使用的 Function
		renderHeader: {
			type: Function,
			default: null
		},
		// 用来格式化内容
		formatter: {
			type: Function,
			default: null
		}
	},
	setup(props, { slots }) {
		const registerColumn = inject('registerColumn');
		const unregisterColumn = inject('unregisterColumn');

		// 创建表头渲染函数用于自定义表头内容
		const createRenderHeader = () => {
			if (!props.renderHeader) return null;

			return {
				name: 'TableHeaderSlot',
				functional: true,
				props: ['column', 'columnIndex'],
				render(h, ctx) {
					// 调用 renderHeader 函数，参数格式参考 element-ui
					return props.renderHeader({
						column: ctx.props.column,
						$index: ctx.props.columnIndex
					});
				}
			};
		};

		// 创建渲染函数用于自定义插槽内容
		const createRenderSlot = () => {
			if (!slots.default) return null;

			return {
				name: 'TableColumnSlot',
				functional: true,
				props: ['row', 'column', 'rowIndex'],
				render(h, ctx) {
					// 在 Vue 2.7 中，通过 ctx.props 获取传入的参数
					return slots.default({
						row: ctx.props.row,
						column: ctx.props.column,
						rowIndex: ctx.props.rowIndex
					});
				}
			};
		};

		// 列配置
		const columnConfig = {
			...props,
			renderHeaderSlot: createRenderHeader(),
			renderSlot: createRenderSlot()
		};

		// 注册列
		onMounted(() => {
			if (registerColumn) {
				registerColumn(columnConfig);
			}
		});

		// 注销列
		onBeforeUnmount(() => {
			if (unregisterColumn) {
				unregisterColumn(props.prop);
			}
		});

		// 返回渲染函数
		return () => null;
	}
};
</script>
